export default __webpack_public_path__ + "static/media/Dad&Eric.755ac77d.jpg";